import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'empty-page-component',
  templateUrl: './empty-page.component.html',
  styleUrl: './empty-page.component.scss',
  imports: [
    CommonModule,
    RouterLink,
    TranslateModule
  ]
})
export class EmptyPageComponent {
  public lang: string | null = null;
  constructor(private translateService: TranslateService) {
    this.lang = this.translateService.currentLang;
  }
}